import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareRoadmapClassicRoute: InvariantJiraRoute = {
	name: 'software-roadmap-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap',
};
